import StarRating from "@components/StarRating"

interface Props {
  text: string
  author: string
}

export default function TestimonialCard({ text, author }: Props) {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white px-6 py-5 text-left shadow-xs">
      <StarRating rating={5} />
      <p className="text-text-secondary text-sm leading-relaxed">{text}</p>
      <p className="text-base font-semibold text-black">{author}</p>
    </div>
  )
}
